import { takeLatest, put, all, call } from 'redux-saga/effects';
import LoanDisbursementActionTypes from './loan-disbursement.types';
import {
	getLoanDisbursementDetailsSuccess,
	getLoanDisbursementDetailsFailure,
	getLoanDisbursementDetailsResponseChanged,
	getOfficerBranchDetailsSuccess,
	getOfficerBranchDetailsFailure,
	getOfficerBranchDetailsResponseChanged,
	fetchAllEconomicActivityFailure,
	fetchAllEconomicActivitySuccess,
	fetchAllEconomicActivityResponseChanged,
} from './loan-disbursement.action';
import {
	LoanDisbursementListGet,
	officerBranchListGet,
	allEconomicActivityFetch,
} from './loan-disbursement.service';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET LOAN DISBURSEMENT REPORT DETAILS  ******************** */

export function* getLoanDisbursementList({ payload }: any) {
	try {
		const key = 'LoanDisbursementKey';
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			officerID,
			branchID,
			groupID,
			funderID,
			PurposeOfLoanID,
			EconomicActivityID,
			loanstatus,
			loanapprove,
			cycle,
			TABSLOANTYPE,
			TABSDATE,
			TABSCENTERTYPE,
			databaseName,
			requestStartDate,
			requestEndDate,
			IsThriftActive,
			userLevel,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userName,
			Location: userAccessBranchID,
			OfficerID: officerID,
			BranchID: branchID,
			GroupID: groupID,
			InvestorID: funderID,
			PurposeOfLoanID: PurposeOfLoanID,
			EconomicActivityID: EconomicActivityID,
			LoanStatus: loanstatus,
			LoanApprove: loanapprove,
			LoanCycle: cycle,
			LoanType: TABSLOANTYPE,
			SortByMethod: TABSDATE,
			CenterType: TABSCENTERTYPE,
			DatabaseName: databaseName,
			FromDate: requestStartDate,
			ToDate: requestEndDate,
			IsThriftActive: IsThriftActive,
			UserLevel: userLevel,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(LoanDisbursementListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanDisbursementDetailsFailure(responseData.data));
		} else {
			yield put(getLoanDisbursementDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanDisbursementDetailsFailure(error));
	}
}

export function* resetGetLoanDisbursementListResponse() {
	yield put(getLoanDisbursementDetailsResponseChanged());
}

export function* onGetLoanDisbursementListDetails() {
	yield takeLatest(
		LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_START,
		getLoanDisbursementList,
	);
}

export function* onGetLoanDisbursementListResponseReset() {
	yield takeLatest(
		LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_RESPONSE_RESET,
		resetGetLoanDisbursementListResponse,
	);
}

/** *********************  END GET LOAN DISBURSEMENT REPORT LIST ******************** */

/** *********************  START GET OFFICER BASED ON BRANCH DETAILS  ******************** */

export function* getOfficerBranchList({ payload }: any) {
	try {
		const key = 'GetOfficerListBranchKey';
		const { companyID, userID, centerID, branchID, databaseName, userLevel, userRole } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(officerBranchListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOfficerBranchDetailsFailure(responseData.data));
		} else {
			yield put(getOfficerBranchDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOfficerBranchDetailsFailure(error));
	}
}

export function* resetGetOfficerBranchListResponse() {
	yield put(getOfficerBranchDetailsResponseChanged());
}

export function* onGetOfficerBranchListDetails() {
	yield takeLatest(
		LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_START,
		getOfficerBranchList,
	);
}

export function* onGetOfficerBranchListResponseReset() {
	yield takeLatest(
		LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_RESPONSE_RESET,
		resetGetOfficerBranchListResponse,
	);
}

/** *********************  END GET OFFICER BASED ON BRANCH LIST ******************** */

/** *********************  START FETCH ALL PRODUCT TYPE LIST  ******************** */
export function* fetchAllEconomicActivitysList({ payload }: any) {
	try {
		const key = 'FetchAllEconomicActivityTypesKey';
		const { companyID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allEconomicActivityFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllEconomicActivityFailure(responseData.data));
		} else {
			yield put(fetchAllEconomicActivitySuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllEconomicActivityFailure(error));
	}
}

export function* resetFetchAllEconomicActivitysResponse() {
	yield put(fetchAllEconomicActivityResponseChanged());
}

export function* onFetchAllEconomicActivitysDetails() {
	yield takeLatest(
		LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_START,
		fetchAllEconomicActivitysList,
	);
}

export function* onFetchAllEconomicActivitysResponseReset() {
	yield takeLatest(
		LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_RESPONSE_RESET,
		resetFetchAllEconomicActivitysResponse,
	);
}
/** *********************  END FETCH ALL PRODUCT TYPE LIST ******************** */

export function* reportLoanDisbursementSaga() {
	yield all([
		call(onGetLoanDisbursementListDetails),
		call(onGetLoanDisbursementListResponseReset),
		call(onGetOfficerBranchListDetails),
		call(onGetOfficerBranchListResponseReset),
		call(onFetchAllEconomicActivitysDetails),
		call(onFetchAllEconomicActivitysResponseReset),
	]);
}
